import { render } from "./WorldsModal.vue?vue&type=template&id=411f0a1b&scoped=true"
import script from "./WorldsModal.vue?vue&type=script&lang=js"
export * from "./WorldsModal.vue?vue&type=script&lang=js"

import "./WorldsModal.vue?vue&type=style&index=0&id=411f0a1b&scoped=true&lang=css"
import "./WorldsModal.vue?vue&type=style&index=1&id=411f0a1b&lang=css"

import exportComponent from "/Users/apple/Documents/Programing/sonak/sonak_2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411f0a1b"]])

export default __exports__